export const CraftPage = () => {
  return (
    <div className="craft-page">
      Craft page not unlocked yet.
    </div>
  )
};